import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Table, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { analytics } from 'app/utils/segment';
import { useTableHistory } from 'hooks/useTableHistory/useTableHistory';
import styles from './tableFlowRow.module.scss';
const flowAttributes = {
    pstn_phone: {
        icon: 'phone',
        path: 'phone',
    },
    widget_chat: {
        icon: 'chat',
        path: 'chat',
    },
    email: {
        icon: 'mail',
        path: 'email',
    },
    messenger: {
        icon: 'messenger',
        path: 'dixa-messenger',
    },
};
function getIconName(channel) {
    return flowAttributes[channel].icon;
}
function getUrl(channel, flowId) {
    const getFlowPath = () => flowAttributes[channel].path;
    return `/settings/${getFlowPath()}/flow/${flowId}`;
}
export const TableFlowRow = ({ scheduleId, active, channel, id, name, }) => {
    const isInvalid = !flowAttributes[channel];
    const { onToggle } = useTableHistory();
    return (_jsx(Table.Tr, Object.assign({ className: styles.root }, { children: _jsx(Table.Td, Object.assign({ className: classnames(styles.name, {
                [styles.nameIsActive]: !isInvalid && active,
            }) }, { children: isInvalid ? (_jsx(Text.Paragraph, Object.assign({ className: styles.flowName }, { children: "Invalid flow data" }))) : (_jsxs(_Fragment, { children: [_jsx(Icon, { className: styles.icon, name: getIconName(channel) }), _jsx(Text.Paragraph, Object.assign({ className: styles.flowName }, { children: name })), _jsx(Link, Object.assign({ className: styles.flowLink, onClick: () => {
                            onToggle(scheduleId, true);
                            analytics.businessHoursGoToFlowClicked();
                        }, to: getUrl(channel, id), state: {
                            shouldGoBack: true,
                            backButtonText: 'Back to business hours',
                            goBackPath: '/settings/businesshours',
                        } }, { children: "Go to flow" }))] })) })) }), id));
};
